import {useMemo, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {formHelpers} from '../utils/helpers';

export const useFormHelpers = ({employeeIdKey = 'employee_id'} = {}) => {
  const [t] = useTranslation(['main', 'budgets']);

  const {employees, employeeEmail} = useSelector(state => ({
    employees: state?.company?.employees || [],
    employeeEmail: state?.user?.employee?.email,
  }));

  const placeholderEnter = (key) =>
    t('placeholderTemplates.enter', {name: t(key).toLowerCase()});

  const placeholderSelect = (key) =>
    t('placeholderTemplates.select', {name: t(key).toLowerCase()});

  // Default employee options (no extra params)
  const employeeOptions = useMemo(() => {
    return formHelpers.getEmployeeOptions({
      employees, employeeEmail, t, idKey: employeeIdKey
    });
  }, [employees, employeeEmail, employeeIdKey, t]);

  // Function to compute employee options with additional keys when needed
  const getEmployeeOptions = useCallback((extra = {}) => {
    // Merge base params with any extra keys provided by the caller
    return formHelpers.getEmployeeOptions({employees, employeeEmail, t, ...extra});
  }, [employees, employeeEmail, t]);

  return {
    placeholderEnter,
    placeholderSelect,
    employeeOptions,
    getEmployeeOptions,
  };
}
